import { useEffect, useState } from "react";
import { recordWebsiteVisit } from "../utils/api";

const padCount = (value) => {
  const digits = String(Math.max(0, Math.floor(Number(value) || 0)));
  return digits.padStart(Math.max(6, digits.length), "0");
};

const VisitorCounter = ({ className = "" }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const [ok, data] = await recordWebsiteVisit();
      if (!cancelled && ok) {
        setCount(data?.uniqueVisitors ?? 0);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  if (count === null) return null;

  return (
    <div className={`flex flex-col items-center gap-1.5 ${className}`}>
      <p className="text-xs font-semibold tracking-[0.18em] text-slate-400">
        WEBSITE VISITORS
      </p>
      <div className="flex items-center gap-0.5">
        {padCount(count)
          .split("")
          .map((digit, index) => (
            <span
              key={`${digit}-${index}`}
              className="inline-flex h-7 w-5 items-center justify-center rounded-sm border border-emerald-400/25 bg-[#0b1224] font-mono text-sm font-bold text-emerald-300 shadow-[inset_0_-1px_0_rgba(16,185,129,0.25)]"
            >
              {digit}
            </span>
          ))}
      </div>
    </div>
  );
};

export default VisitorCounter;
